export interface ParsedFloorTable {
  id: string;
  label: string;
  capacity: number;
  zone: string | null;
}

export function parseFloorTables(raw: string | undefined): ParsedFloorTable[] {
  if (!raw?.trim()) {
    return [];
  }
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed
      .filter((entry): entry is ParsedFloorTable => {
        if (typeof entry !== 'object' || entry == null) {
          return false;
        }
        const table = entry as Record<string, unknown>;
        return typeof table.id === 'string' && typeof table.label === 'string';
      })
      .map((table) => ({
        id: table.id,
        label: table.label,
        capacity: typeof table.capacity === 'number' ? table.capacity : 0,
        zone: typeof table.zone === 'string' ? table.zone : null,
      }));
  } catch {
    return [];
  }
}

export function formatFloorTables(tables: readonly ParsedFloorTable[]): string {
  if (tables.length === 0) {
    return '';
  }
  return JSON.stringify(
    tables.map((table) => ({
      id: table.id,
      label: table.label,
      capacity: table.capacity,
      zone: table.zone,
    })),
  );
}

function formatTableOptionLabel(table: ParsedFloorTable, showCapacity: boolean): string {
  const zone = table.zone ? ` · ${table.zone}` : '';
  const capacity = showCapacity ? ` (${table.capacity})` : '';
  return `${table.label}${zone}${capacity}`;
}

export function renderFloorTableSelect(
  tables: ParsedFloorTable[],
  showCapacity: boolean,
  escapeHtml: (value: string) => string,
  tableLabel = 'Tisch',
): string {
  if (tables.length === 0) {
    return '';
  }
  const options = tables
    .map(
      (table) =>
        `<option value="${escapeHtml(table.id)}">${escapeHtml(formatTableOptionLabel(table, showCapacity))}</option>`,
    )
    .join('');
  return `<label class="ws-form__field ws-form__field--wide"><span>${escapeHtml(tableLabel)}<abbr class="ws-form__required" title="*">*</abbr></span><select name="tableId" required>${options}</select></label>`;
}
